import AuthService from './AuthService';
import Axios, {AxiosError, AxiosResponse} from "axios";

const baseEndpoint = process.env.DOMAIN;
const collabEndpoint = `${baseEndpoint}/collab`;
const hclEndpoint = `${baseEndpoint}/hcl`;
const phoenixEndpoint = `${baseEndpoint}/phoenix`;
const beEndpoint = `${baseEndpoint}/bayesian`;
const csEndpoint = `${baseEndpoint}/circsim`;
const esEndpoint = `${baseEndpoint}/expert`;
const pfEndpoint = `${baseEndpoint}/pf`;
const componentEndpoint = `${baseEndpoint}/components`;
const authEndpoint = `${baseEndpoint}/auth`;
const loginEndPoint = `${authEndpoint}/token-obtain/`;
const refreshEndpoint = `${authEndpoint}/token-refresh/`;
const userPreferencesEndpoint = `${collabEndpoint}/user`;

const model_path = '/model';
const component_path = '/components';
const project_path = '/project';
const subsystem_path = '/subsystem';
const tree_path = '/tree';

class APIManagerV2 {

  private failureCallback: (e: any) => void;

  constructor(failureCallback: (message: string) => void) {
    this.failureCallback = (e: any) => failureCallback(e.toString());
  }

  /**
   * GET with authorization token
   * @param url {string} - request endpoint
   * @param onSuccess {(response: AxiosResponse) => void} - success callback
   * @param onFailure {(e: any) => void} - optional
   */
  private get(url: string, onSuccess: (response: AxiosResponse) => void, onFailure: (e: any) => void = this.failureCallback) {
    Axios.get(url, {
      headers: {
        Authorization: `JWT ${AuthService.getToken()}`
      }
    }).then(onSuccess).catch(onFailure);
  }

  getPhoenixTreeData(treeId: number, onSuccess: (response: AxiosResponse) => void, onFailure: (e: any) => void = this.failureCallback) {
    this.get(`${phoenixEndpoint}${tree_path}/${treeId}/?include_tree_data=true`, onSuccess, onFailure);
  }

  getHCLTreeData(treeId: number, onSuccess: (response: AxiosResponse) => void, onFailure: (e: any) => void = this.failureCallback) {
    this.get(`${hclEndpoint}${tree_path}/${treeId}/?include_tree_data=true`, onSuccess, onFailure);
  }

}

export default APIManagerV2;
